import { Injectable, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { IBreadcrumb } from './breadcrumb.component';


@Injectable({
    providedIn: 'root'
})
export class BreadcrumbService {

    private breadcrumbSubject: Subject<IBreadcrumb[]> = new Subject<IBreadcrumb[]>();
    public breadcrumbObserver = this.breadcrumbSubject.asObservable();

    constructor() {
    }

    public breadcrumbChanged(newBreadcrumb) {
        this.breadcrumbSubject.next(newBreadcrumb);
    }
}
